import {
  ROUTE_DASH_USERS,
  ROUTE_DASH_DEPARTMENTS,
  ROUTE_DASH_CONTRACTORS,
  ROUTE_DASH_GROUPS,
  ROUTE_DASH_TASKS,
  ROUTE_DASH_COMPANIES,
  ROUTE_DASH_USER_TRAFFIC_LOG,
  ROUTE_DASH_REPORT_BEK,
  ROUTE_DASH_DAILY_LOADING_POINT,
  ROUTE_DASH_REPORT_TCM,
  ROUTE_DASH_REPORT_IMM,
  ROUTE_DASH_REPORT_BARGE_CHECKLIST,
  ROUTE_DASH_DATA_VALIDATION,
  ROUTE_DASH_ACTUAL_LOADING,
  ROUTE_DASH_REPORT_TRIP_COUNT,
  ROUTE_DASH_BLASTING_REPORT,
  ROUTE_DASH_STOCK_OPNAME
} from 'fixtures/routes';
import {
  dashboardRead,
  groupRead,
  taskRead,
  reportRead,
  companyRead,
  contractorRead,
  BEKReportRead,
  IMMReportRead,
  reportBargeChecklistRead,
  actualLoadingRead,
  userLogRead,
  contractorReportOBRead,
  contractorReportRSRead,
  blastingReportRead,
  stockOpnameRead
} from 'fixtures/permissions';

export const routeList = [
  {
    name: 'Report',
    icon: 'clipboard-check',
    expanded: false,
    children: [
      {
        name: 'TCM',
        path: ROUTE_DASH_REPORT_TCM,
        permission: reportRead,
        icon: 'clipboard-check',
      },
      {
        name: 'Daily Report',
        path: ROUTE_DASH_REPORT_BEK,
        permission: BEKReportRead,
        icon: 'clipboard-check',
      },
      {
        name: 'Daily Loading Point',
        path: ROUTE_DASH_DAILY_LOADING_POINT,
        permission: BEKReportRead,
        icon: 'clipboard-check',
      },
      {
        name: 'IMM',
        path: ROUTE_DASH_REPORT_IMM,
        permission: IMMReportRead,
        icon: 'clipboard-check',
      },
      {
        name: 'Barge Checklist',
        path: ROUTE_DASH_REPORT_BARGE_CHECKLIST,
        permission: reportBargeChecklistRead,
        icon: 'clipboard-check',
      },
      {
        name: 'Trip Count',
        path: ROUTE_DASH_REPORT_TRIP_COUNT,
        permission: reportBargeChecklistRead,
        icon: 'clipboard-check',
      },
    ]
  },
  {
    name: 'Task',
    path: ROUTE_DASH_TASKS,
    permission: taskRead,
    icon: 'clipboard-list',
  },
  {
    name: 'Data Validation',
    path: ROUTE_DASH_DATA_VALIDATION,
    permission: contractorReportOBRead || contractorReportRSRead,
    icon: 'award',
  },
  {
    name: 'Actual Loading',
    path: ROUTE_DASH_ACTUAL_LOADING,
    permission: actualLoadingRead,
    icon: 'file-alt',
  },
  {
    name: 'Blasting Report',
    path: ROUTE_DASH_BLASTING_REPORT,
    permission: blastingReportRead,
    icon: 'envelope',
  },
  {
    name: 'Stock Opname',
    path: ROUTE_DASH_STOCK_OPNAME,
    permission: stockOpnameRead,
    icon: 'warehouse',
  },
  {
    name: 'Settings',
    icon: 'cog',
    expanded: false,
    children: [
      {
        name: 'User',
        path: ROUTE_DASH_USERS,
        permission: dashboardRead,
        icon: 'user',
      },
      {
        name: 'Company',
        path: ROUTE_DASH_COMPANIES,
        permission: companyRead,
        icon: 'city',
      },
      {
        name: 'Group Management',
        path: ROUTE_DASH_GROUPS,
        permission: groupRead,
        icon: 'user-friends',
      },
      {
        name: 'Contractor',
        path: ROUTE_DASH_CONTRACTORS,
        permission: contractorRead,
        icon: 'toolbox',
      },
      {
        name: 'Department',
        path: ROUTE_DASH_DEPARTMENTS,
        permission: dashboardRead,
        icon: 'building',
      },
    ]
  },
  {
    name: 'User Traffic Log',
    path: ROUTE_DASH_USER_TRAFFIC_LOG,
    permission: userLogRead,
    icon: 'history',
  }
]
